var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { ArcoIconWrapper } from '@m4b-design/utils';
import { Typography } from '@arco-design/web-react';
import { useConfigContext } from '@m4b-design/config-provider';
import { IconLeft, IconRight } from '@arco-design/iconbox-react-m4b-next';
import ArcoPagination from './core/pagination';
import './style/index.less';
import { useI18nCopy } from './hooks/useI18nCopy';
var Text = Typography.Text;
var PaginationRender = function (props, ref) {
    var globalPrefixCls = useConfigContext().prefixCls;
    var t = useI18nCopy();
    var prefixCls = "".concat(globalPrefixCls, "-pagination");
    var className = props.className, simple = props.simple, showTotal = props.showTotal, _a = props.showPageWhenSimple, showPageWhenSimple = _a === void 0 ? true : _a, textMode = props.textMode, textModeConfig = props.textModeConfig, disabledMore = props.disabledMore, _b = props.icons, icons = _b === void 0 ? {} : _b, rest = __rest(props, ["className", "simple", "showTotal", "showPageWhenSimple", "textMode", "textModeConfig", "disabledMore", "icons"]);
    var baseClsName = cx(prefixCls, className, getSimpleClsName());
    var textModeClsName = cx(baseClsName, "".concat(prefixCls, "-text-mode"));
    var textModeBtnClsName = "".concat(textModeClsName, "-btn");
    var textModeProps = textMode
        ? {
            className: textModeClsName,
            simple: true,
            pageSize: 1,
            sizeCanChange: false,
            itemRender: textModeRender,
        }
        : {};
    function getSimpleClsName() {
        var clsNameArr = [];
        if (simple && !textMode) {
            clsNameArr.push("".concat(prefixCls, "-simple"));
            if (!showPageWhenSimple) {
                clsNameArr.push("".concat(prefixCls, "-simple-hide-page"));
            }
        }
        return clsNameArr.join(' ');
    }
    function textModeRender(_, type, originElement) {
        var _a = textModeConfig !== null && textModeConfig !== void 0 ? textModeConfig : {}, _b = _a.prevText, prevText = _b === void 0 ? 'Previous' : _b, _c = _a.nextText, nextText = _c === void 0 ? 'Next' : _c, prevDesc = _a.prevDesc, nextDesc = _a.nextDesc, _d = _a.ellipsis, ellipsis = _d === void 0 ? { rows: 2, showTooltip: true } : _d;
        if (type === 'prev') {
            return (React.createElement("div", { className: "".concat(textModeBtnClsName, "-area ").concat(textModeBtnClsName, "-prev") },
                React.createElement("div", { className: "".concat(textModeBtnClsName) },
                    React.createElement("div", { className: "".concat(textModeBtnClsName, "-icon") }, originElement)),
                React.createElement("div", { className: "".concat(textModeBtnClsName, "-text-area") },
                    React.createElement("div", { className: "".concat(textModeBtnClsName, "-text") }, prevText),
                    prevDesc && (React.createElement(Text, { className: "".concat(textModeBtnClsName, "-desc"), ellipsis: ellipsis }, prevDesc)))));
        }
        // type === 'next'
        return (React.createElement("div", { className: "".concat(textModeBtnClsName, "-area ").concat(textModeBtnClsName, "-next") },
            React.createElement("div", { className: "".concat(textModeBtnClsName, "-text-area") },
                React.createElement("div", { className: "".concat(textModeBtnClsName, "-text") }, nextText),
                nextDesc && (React.createElement(Text, { className: "".concat(textModeBtnClsName, "-desc"), ellipsis: ellipsis }, nextDesc))),
            React.createElement("div", { className: "".concat(textModeBtnClsName) },
                React.createElement("div", { className: "".concat(textModeBtnClsName, "-icon") }, originElement))));
    }
    var defaultTotalRender = function (total, range) {
        var _a;
        return (_a = t.ofTotal) === null || _a === void 0 ? void 0 : _a.replace(/(#{from})|(#{to})|(#{total})/g, function (match) {
            if (match === '#{from}')
                return range[0].toString();
            if (match === '#{to}')
                return total < range[1] ? total.toString() : range[1].toString();
            if (match === '#{total}')
                return total.toString();
        });
    };
    return (React.createElement(ArcoPagination, __assign({ "data-tid": "m4b_pagination", ref: ref, className: baseClsName, simple: simple, showTotal: showTotal === true ? defaultTotalRender : showTotal, disabledMore: disabledMore, icons: __assign({ prev: React.createElement(ArcoIconWrapper, { Icon: IconLeft }), next: React.createElement(ArcoIconWrapper, { Icon: IconRight }) }, icons) }, rest, textModeProps)));
};
var Pagination = forwardRef(PaginationRender);
Pagination.displayName = 'Pagination';
export default Pagination;
